import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import useTranslation from 'next-translate/useTranslation';
import { LoginLayout } from '@components/Layouts/LoginLayout';
import { ILoginRequest, useAuthenticateUserMutation } from '@/stores/userApi';
import { ActivityIndicator } from '@components/ActivityIndicator/ActivityIndicator';
import { useShoppingCartRoute } from '@/services/feature-toggles-service';
import { APP_ROUTES } from '@constants/constants';
import styles from './loginPopup.module.scss';

const LoginPopup = () => {
  const [authenticateUser] = useAuthenticateUserMutation();

  const { t } = useTranslation('login');

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [noUsernameError, setNoUsernameError] = useState('');
  const [noPasswordError, setNoPasswordError] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const shoppingCartRoute = useShoppingCartRoute();

  const handleLogin = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    if (!username) {
      setNoUsernameError(t('error.empty-field'));
      return;
    }
    setNoUsernameError('');

    if (!password) {
      setNoPasswordError(t('error.empty-field'));
      return;
    }
    setNoPasswordError('');

    const values: ILoginRequest = { username, password };
    try {
      setError('');
      setIsLoading(true);
      const loginResponse = await authenticateUser(values).unwrap();
      const urlParams = new URLSearchParams(window.location.search);
      const redirectUrl = urlParams.get('returnUrl') ? loginResponse.redirectUrl : shoppingCartRoute;
      window.location.replace(redirectUrl);
    } catch (error) {
      setError(t('error.incorrect-username-or-password'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <ActivityIndicator />}

      <Row className={styles.form}>
        <Col>
          <Form>
            <Form.Group controlId="formUsername">
              <Form.Label>{t('label.username')}</Form.Label>
              <Form.Control type="text" placeholder={t('label.username')} value={username} onChange={(e) => setUsername(e.target.value)} />
              {noUsernameError && <p className="text-danger">{noUsernameError}</p>}
            </Form.Group>

            <Form.Group controlId="formPassword">
              <Form.Label>{t('label.password')}</Form.Label>
              <Form.Control
                type="password"
                placeholder={t('label.password')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {error && <p className="text-danger">{error}</p>}
              {noPasswordError && <p className="text-danger">{noPasswordError}</p>}
            </Form.Group>
            <Row>
              <a href={APP_ROUTES.FORGOT_PASSWORD} className={styles.forgotPasswordLink}>
                {t('forgot.password')}
              </a>
              <Col>
                <Button type="submit" size={'xl' as any} variant="primary" className={styles.loginButton} onClick={(e) => handleLogin(e)}>
                  {t('button.login')}
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>

      <div className={`${styles.footer} p-3`}>
        <div className="h2 text-white">{t('Geen Carel Lurvink account?')}</div>
        <a href={APP_ROUTES.REGISTER} className={styles.registerButton}>
          {t('button.register')}
        </a>
      </div>
    </>
  );
};

LoginPopup.getLayout = function getLayout(page: React.ReactNode) {
  return <LoginLayout>{page}</LoginLayout>;
};

export default LoginPopup;
